/* eslint-disable security/detect-object-injection */
import * as React from 'react';
import { Button, Form, InputGroup } from 'react-bootstrap';

import { PatcherContext } from '@/helper/context';
import { camelToTitle } from '@/helper/utility';

interface Properties {
  name: string;
  displayName?: string;
  size?: string;
  money?: boolean;
  perHour?: boolean;
  percentage?: boolean;
  days?: boolean;
  negative?: boolean;
  inactive: boolean;
}

export function PatcherInputNumber({
  name,
  displayName,
  size = 'col-12',
  money = false,
  perHour = false,
  percentage = false,
  days = false,
  negative = false,
  inactive = false
}: Properties) {
  displayName = displayName || camelToTitle(name);
  const { onChange, values, errors, disabled } = React.useContext(PatcherContext);

  const [valueState, setValueState] = React.useState(values[name]);
  const [eventSaver, setEventSaver] = React.useState<React.ChangeEvent<HTMLInputElement>>();
  const [save, setSave] = React.useState(false);

  function update(event: React.ChangeEvent<HTMLInputElement>) {
    setValueState(event.target.value);
    setEventSaver(event);
    setSave(values[name].toString() !== event.target.value);
  }

  function submit() {
    onChange(eventSaver);
    setSave(false);
  }

  return (
    <div className='d-flex'>
      <Form.Group controlId={name} className={`mt-3 ${size}`}>
        <InputGroup hasValidation>
          <InputGroup.Text>{displayName}</InputGroup.Text>
          {money && <InputGroup.Text>&#36;</InputGroup.Text>}
          <Form.Control
            aria-label={name}
            name={name}
            type='number'
            disabled={disabled || inactive}
            min={negative ? '-99_999_999.99' : '0'}
            max='99_999_999.99'
            value={valueState}
            onChange={update}
            isInvalid={errors[name] ? true : false}
          />
          {perHour && <InputGroup.Text>Per Hour</InputGroup.Text>}
          {percentage && <InputGroup.Text>&#37;</InputGroup.Text>}
          {days && <InputGroup.Text>Days</InputGroup.Text>}
          <Form.Control.Feedback type='invalid'>{errors[name]}</Form.Control.Feedback>
        </InputGroup>
      </Form.Group>
      {save && (
        <Button variant='primary' className='ms-3 mt-3' style={{ height: 'fit-content' }} onClick={submit}>
          Save
        </Button>
      )}
    </div>
  );
}
